"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var json2_1 = require("./json2");
window.JSON = window.JSON || json2_1.JSON;
//# sourceMappingURL=json.js.map